import { Body, BulletList, Heading } from "@biom3/react";
import type { RichTextField } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";

export const CampaignRules = ({
  field,
}: { field: RichTextField | null | undefined }) => {
  return (
    <PrismicRichText
      field={field}
      components={{
        list: (p) => (
          <BulletList sx={{ "& > ul": { gap: "base.spacing.x2" } }} key={p.key}>
            {p.children}
          </BulletList>
        ),
        listItem: ({ key, ...p }) => (
          <BulletList.Item key={key}>{p.children}</BulletList.Item>
        ),
        paragraph: ({ key, ...p }) => (
          <Body
            key={key}
            size="medium"
            sx={{
              color: "base.color.text.body.secondary",
            }}
          >
            {p.children}
          </Body>
        ),
        heading1: ({ key, ...p }) => (
          <Heading
            key={key}
            size="xSmall"
            sx={{ mt: "base.spacing.x4", mb: "base.spacing.x2" }}
          >
            {p.children}
          </Heading>
        ),
      }}
    />
  );
};
